import apiClient from './apiClient'

export {
  saveCustomerOrderManager,
  saveBrowsingHistory,
  getTechSupport,
  getStatisticsDynamicBarrage,
  getStatisticsProjectBarrage
}

async function saveCustomerOrderManager({
  mobile,
  targetType,
  target,
  entryPoint,
  serviceName,
  landingPageId,
  companyId,
  customerApp = process.env.CUSTOMER_APP,
  province = '',
  city = '',
  name = '',
  style = '',
  area = '',
  houseType = '',
  afterSalesProblem = '',
  personId = '',
  salesPersonId = ''
}) {
  const res = await apiClient.post('saveCustomerOrderManager.do', null, {
    params: {
      mobile,
      targetType,
      target,
      entryPoint,
      serviceName,
      landingPageId,
      companyId,
      customerApp,
      province,
      city,
      name,
      style,
      area,
      houseType,
      afterSalesProblem,
      personId,
      salesPersonId
    }
  })
  if (res.data.code === '200') {
    return {
      judge: true,
      msg: '预约成功'
    }
  } else {
    return {
      judge: false,
      msg: '预约失败,请稍后再试'
    }
  }
}

async function saveBrowsingHistory({
  targetType = 3,
  targetId,
  companyId,
  sales = '', // 销售人员id不是必传的
  personId = '',
  source = 27
}) {
  const res = await apiClient.post('company/v2/browsing-history/save', {
    targetType,
    targetId,
    companyId,
    sales,
    personId,
    source
  })

  return res.data
}

async function getTechSupport(params) {
  const res = await apiClient.get('getTechnicalSupport.do', {
    params
  })
  return res.data
}
// {"companyId":65,"pageNo":1,"pageSize":5}
async function getStatisticsDynamicBarrage(params) {
  const res = await apiClient.post('/statistics/dynamic/barrage', params)
  return res.data
}
async function getStatisticsProjectBarrage(params) {
  const res = await apiClient.post('/statistics/project/barrage', params)
  return res.data
}
export async function getStatisticsMap(companyId) {
  const res = await apiClient.post('/statistics/map/project', { companyId })
  return res.data
}
